import type { SignalStatus } from '@latitude/signal';

export type UserAccessStatus = {
  color: SignalStatus;
  title: string;
  subTitle: string;
};

const USER_ACCESS_STATUS: Record<string, UserAccessStatus> = {
  ACTIVE: {
    color: 'success',
    title: 'Active',
    subTitle: 'Last logged in within 30 days',
  },
  INACTIVE: {
    color: 'warning',
    title: 'Idle',
    subTitle: 'Last logged in 30 or more days ago',
  },
  BLOCKED: {
    color: 'danger',
    title: 'Lost',
    subTitle: 'Marked as lost',
  },
  INOPERATIVE: {
    color: 'default',
    title: 'Inoperative',
    subTitle: 'User can’t be reactivated',
  },
};

const UNKNOWN_USER_ACCESS_STATUS: UserAccessStatus = {
  color: 'default',
  title: 'Unknown',
  subTitle: 'User device is not available',
};

export function getUserAccessStatus(status?: string | null): UserAccessStatus {
  if (!status) {
    return UNKNOWN_USER_ACCESS_STATUS;
  }
  return USER_ACCESS_STATUS[status] ?? UNKNOWN_USER_ACCESS_STATUS;
}
